import { render, staticRenderFns } from "./VerifyDocument.vue?vue&type=template&id=3157e664&scoped=true"
import script from "./VerifyDocument.vue?vue&type=script&lang=js"
export * from "./VerifyDocument.vue?vue&type=script&lang=js"
import style0 from "./VerifyDocument.vue?vue&type=style&index=0&id=3157e664&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3157e664",
  null
  
)

/* custom blocks */
import block0 from "./VerifyDocument.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports